import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import { saveTransactionAction } from '../../redux/actions/MainAction'
import { setStatusChangeIRAction,setStatusSaveIRAction } from '../../redux/actions/AppAction.js'
import { Input, DatePicker, Select, DropDownList, InputDecimal ,InputDecimalIR,InputDecimalTax,Div,CheckerBox} from "../core";
import $ from 'jquery'
import utilityHelper from '../../helpers/helperUtil'
import ReactTooltip from 'react-tooltip'

import Checkbox from "@material-ui/core/Checkbox";
import {
    updateIR_OneTimeVendorAction,
    getIR_ReferenceAction
} from '../../redux/actions/IRAction'
import {
    getExchangeRateAction,
    getVendorInfoAction,
    getVendorInformationAction,
    getBusinessPlaceAction,
    getWithCodeAction,
    getWithCodeByVendorAction,
    GETEWHTConditionValidationCheckInquiryAction,
} from '../../redux/actions/MasterAction'

import {msg} from '../../components/Notifications/MsgBox';
import { Storage,MessageText } from '../../configs'
import validateUtil from '../../helpers/validateUtil'

import {
    data_t_IR_DETAIL,
  } from '../../configs/datas'
import { json } from "body-parser"
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

class InvoiceReceive extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ...props,
            valueTabs:0,
            openIR: false,
            isTaxType: false,
            selectedOption: null,
            irBalance: 0,
            totalWithoutVat: 0,
            business_places: [],
            with_codes : [],
            vendors: [],
            checkall: true,
            irData: {
                transaction_no: "",
                invoice_date: "",
                posting_date: "",
                reference: "",
                ir_text: "",
                amount: "0",
                currency: "THB",
                tax_type: "",
                bus_place: "",
                baseline_date: "",
                payt_terms: "0",
                payt_term_days: "0",
                pmt_method: "",
                pmt_meth_sup: "",
                brach_code: "",
                exch_rate: "0",
                exch_rate_date: "",
                exch_rate_fixed: "",
                tax_number3: "",
                wtax_code1: "",
                wtax_fc1: "",
                wtax_code2: "",
                wtax_fc2: "",
                invoicing_party: "",
                vendor_code: "",
                vendor_name: "",
                bank_acc: "",
                bank_detail: "",
                ir_detail_id: "",
                running:0,
                calculate_tax_flag:1,
                tax_amount:"",
                due_date:"",
                edit_tax_head:0,
                edit_tax_item:0
            },
            irItem:[
                {
                  transaction_no: "",
                  item_id: "",
                  checked: "",
                  item_text: "",
                  order_unit: "",
                  receive_qty: "",
                  tax_code: "",
                  amount: 0,
                  ir_detail_id: "",
                  running: 0
                }
              ],
            irTax:[],
            irDelete:[],
        }

        this.modelIRDetail = data_t_IR_DETAIL[0];
        this.handleChange = this.handleChange.bind(this)
        this.saveIR = this.saveIR.bind(this)
        this.deleteIR = this.deleteIR.bind(this)
        this.createIR = this.createIR.bind(this)
        this.setEditIR = this.setEditIR.bind(this)
        this.goBack = this.goBack.bind(this)
        this.handleChangeItem = this.handleChangeItem.bind(this)
        this.handleChangeItemTax = this.handleChangeItemTax.bind(this)
        this.calBalance = this.calBalance.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleExchRateChange = this.handleExchRateChange.bind(this)
        this.getVendors = this.getVendors.bind(this)
        this.handleInvoicingPartyChange = this.handleInvoicingPartyChange.bind(this)
        this.handleDecimalBlur = this.handleDecimalBlur.bind(this)
        this.handleDecimalItemBlur = this.handleDecimalItemBlur.bind(this)
        this.handleDecimalItemTaxBlur = this.handleDecimalItemTaxBlur.bind(this)
        window.onChangeTabIR = this.onChangeTabIR.bind(this)
        window.onSelectVendor = this.onSelectVendor.bind(this)
        this.handleSelectAllClick = this.handleSelectAllClick.bind(this)
    }

    onChangeTabIR(){
        this.setState({
            openIR: false,
        })
    }

    getVendors(vendor) {
        let result = null
        const { vendors } = this.state
        result = vendors //&& vendors.filter(f => f.display === vendor)
        if (result) {
            result = utilityHelper.toSelectList(result, "display", "vendoR_CODE")
        }

        return result
    }

    onSelectVendor(item){
        if(item){
            this.setState({
                irData: {
                    ...this.state.irData,
                    invoicing_party:item.vendoR_CODE,
                    vendor_code:item.vendoR_CODE,
                    vendor_name:item.display
                }
            })
        }
    }

    async componentDidMount() {
        this.props.getBusinessPlace()
        .then((response)=>{this.setState({business_places:response.data})})
        let {irData} =this.state
        // this.props.getWithCode()
        // .then((response)=>{console.log("getWithCode ==> response.data",response.data) ;this.setState({with_codes : response.data})})
        // var {t_PO_DETAIL} = this.props;
       
        var {t_PO_DETAIL} = this.props;

        this.props.getWithCodeByVendor("","","",t_PO_DETAIL.vendor_code,"10",t_PO_DETAIL.pmt_method)
        .then((response)=>{
            
            this.setState({with_codes : response.data});
    })
        

        // await this.props.getVendor()
        // .then((response)=>{this.setState({vendors : response.data})})
    }

    componentWillReceiveProps(nextProps) {
        
        if (this.state.oneTimeVendorModal !== nextProps.oneTimeVendorModal) {
            this.setState({
                oneTimeVendorModal: nextProps.oneTimeVendorModal
            })
        }
        let _total = 0
        let t_IR_ITEM=this.props.t_IR_ITEM;
        if(t_IR_ITEM.length === 1 && t_IR_ITEM[0].running === 0 && nextProps.t_IR_ITEM.length>0){
            t_IR_ITEM = nextProps.t_IR_ITEM;
        }
        t_IR_ITEM && t_IR_ITEM.map((m, index)=>{
            if(m.checked === "1"){
                _total +=  utilityHelper.parseFloat(m.amount)
            }
        })
        if(_total > 0){
            this.setState({
                totalWithoutVat:_total
            })
        }
    }

    async saveIR() {
       
        let _dif = false
        let msgError=""
        const {irData} = this.state
        const {t_PO_DETAIL, t_IR_ONE_TIME_VENDOR ,t_GR_ITEM,t_GR_SERVICE,t_GR_SERVICELINE,t_HEADER} = this.props
        const {irDelete} = this.state
        let response
        await this.props.getIR_Reference(this.props.t_PO_DETAIL.po_contract_no, irData.reference, irData.transaction_no, irData.running,irData.invoice_date,irData.vendor_code)
        .then(res => {
            response =res.data  
        });
        let irDesc="อื่นแล้ว" 
        
        // var responseWHT;
        // await this.props.GETEWHTConditionValidationCheckInquiry("10",t_PO_DETAIL.vendor_code , irData.wtax_code1, irData.wtax_code2)
        // .then(res => {
        //     responseWHT =res.data  
        // });

        const resp = await this.props.GETEWHTConditionValidationCheckInquiry("10",irData.vendor_code , irData.wtax_code1, irData.wtax_code2,moment(irData.posting_date).format('YYYY-MM-DD'), irData.pmt_method)

        if (resp.data.flaG_ERROR == "F")
        {
            msgError+=resp.data.messagE_TEXT+"<br/>"
        }
        
        if(response.length > 0){
            _dif = true;
            let referenceDup = response[0].reference
            let runningDup = response[0].running
            let invoiceDateDup = response[0].invoice_date
            let transDup = response[0].transaction_no
            irDesc = response[0].ir_text
            if(t_PO_DETAIL.transaction_no === transDup){ //ซ้ำในเอกสารเดียวกัน
                _dif = false;
                this.props.t_IR_DETAIL && this.props.t_IR_DETAIL.map((m, index)=>{
                    if(m.reference === referenceDup){
                        _dif = true
                        if(_dif && irDelete.length > 0){/*เคส Delete */
                            irDelete.map((n, index)=>{
                                if(n.reference === referenceDup && n.running === runningDup && _dif){
                                    _dif = false;
                                }
                            })
                        }
                    }
                })
            }
        }
        this.props.t_IR_DETAIL && this.props.t_IR_DETAIL.map((m, index)=>{
            if((m.reference === irData.reference && m.running !== irData.running) && m.invoice_date === irData.invoice_date){
                _dif = true
                irDesc=' RRSDocNo: '+t_HEADER.doc_no+' PO/Contract No: '+t_PO_DETAIL.po_contract_no +' แล้ว';
            }
        })

        if(_dif){
            msgError+=("Reference (เลขที่ใบแจ้งหนี้/ใบกำกับภาษี) เลข " + irData.reference + " ถูกใช้ในเอกสาร"+irDesc)+"<br/>"
        }

        var listItemRefresh = this.createIRItem(0,t_PO_DETAIL,t_GR_ITEM,t_GR_SERVICE,t_GR_SERVICELINE);

        this.props.t_IR_ITEM && this.props.t_IR_ITEM.map((m, index) => {
            if (m.checked === "1") {

                listItemRefresh.filter(c => c.item_id == m.item_id).map((it,index)=>{
                    if(m.gr_amount != it.gr_amount)
                        m.gr_amount = it.gr_amount
                    if(m.gr_qty != it.gr_qty)
                        m.gr_qty = it.gr_qty
                });
               
                var checkItemIRGR = 1
                t_GR_ITEM && t_GR_ITEM.map((k, index) => {
                    if (k.checked === "1" && k.item_id === m.item_id) {
                        checkItemIRGR = 0
                    }
                })
                t_GR_SERVICE && t_GR_SERVICE.map((k, index) => {
                    if (k.checked === "1" && k.service_item_id === m.item_id) {
                        checkItemIRGR = 0
                    }
                })
                if(checkItemIRGR){
                    msgError+=("กรุณาตรวจสอบข้อมูล รายการ:"+m.item_text+" ไม่ได้ทำรายการรับสินค้า")+"<br/>"
                }
            }
        })

        let _chekcTaxType=true;
        let _countRowItem = 0;
        const role = Storage.getRole()
        const numeral = require('numeral');
        if(this.state.irItem.length > 0){
            await this.state.irItem.map((element, index) =>{
                if(this.state.irData.tax_type!==undefined){
                    if(element.checked === "1" && element.tax_code === this.state.irData.tax_type){
                        this.setState({
                            isTaxType:true
                        })
                        _chekcTaxType=false
                    }
                }
                if(element.checked === "1" ){
                    _countRowItem++;
                    if(role === "R"){
                        if(element.gr_receive_qty != null && ( element.receive_qty==="" || element.receive_qty === 0.000 || element.receive_qty === "0.000" ) )
                            msgError+=("กรุณาระบุ Item "+element.item_id+" : Receive Qty")+"<br/>"
                        if(( element.amount==="" || element.amount === 0.00 || element.amount === "0.00" ) )
                            msgError+=("กรุณาระบุ Item "+element.item_id+" : Amount")+"<br/>"
                        if(element.amount > utilityHelper.parseFloat(numeral(element.gr_amount).format('0,0.00')) )
                            msgError+=("กรุณาตรวจสอบ Item "+element.item_id+" : มูลค่า IR Amount มากกว่า GR Amount")+"<br/>"
                        if(element.tax_code === "-- select --" || element.tax_code === "" || element.tax_code === null)
                            msgError+=("กรุณาระบุ Item "+element.item_id+" : Tax Code")+"<br/>"
                    }
                }

            });
            let edit_tax_item=this.state.irData.edit_tax_item
            await this.state.irTax.map((element, index) =>{

                if(role === "R" && edit_tax_item){
                    // if( element.tax_doc_currency==="" || element.tax_doc_currency === 0.00 || element.tax_doc_currency === "0.00" ) 
                    //     msgError+=("กรุณาระบุ Tax Code "+element.tax_code+" : Tax doc.currency ต้องมีค่ามากกว่า 0")+"<br/>"
                    if( element.tax_doc_currency==="" ) 
                        msgError+=("กรุณาระบุ Tax Code "+element.tax_code+"")+"<br/>"
                    if( utilityHelper.parseFloat(element.tax_doc_currency) >= utilityHelper.parseFloat(element.base_amount) )
                        msgError+=("กรุณาตรวจสอบ Tax Code "+element.tax_code+" : Tax doc.currency ต้องมีค่าไม่เกิน Base Amount")+"<br/>"
                }

            });
        }

        if(_countRowItem===0 && role === "R"){
            msgError+=("กรุณาเลือกรายการรับสินค้า - บริการ")+"<br/>"
        }
        if(_chekcTaxType && role === "R" && _countRowItem > 0){
            msgError+=("กรุณาตรวจสอบ TaxCode ในระดับรายการให้ตรงกับเอกสาร Tax Type อย่างน้อย 1 รายการ")+"<br/>"
        }
        if(role === "R")
        {
            if((this.state.irData.wtax_fc1!==undefined && this.state.irData.wtax_fc1!=="" && this.state.irData.wtax_fc1!==null) 
            && (this.state.irData.wtax_code1==="" || this.state.irData.wtax_code1===undefined || this.state.irData.wtax_code1===null)){
                msgError+=("กรุณาระบุ W / tax code P1")+"<br/>"
            }
            if((this.state.irData.wtax_fc2!==undefined && this.state.irData.wtax_fc2!=="" && this.state.irData.wtax_fc2!==null) 
            && (this.state.irData.wtax_code2==="" || this.state.irData.wtax_code2===undefined || this.state.irData.wtax_code2===null)){
                msgError+=("กรุณาระบุ W / tax code P2")+"<br/>"
            }
            if(
                   (this.state.irData.wtax_code1!=="" && this.state.irData.wtax_code1!==undefined && this.state.irData.wtax_code1!==null)
                && (this.state.irData.wtax_code2!=="" && this.state.irData.wtax_code2!==undefined && this.state.irData.wtax_code2!==null)
                && ((this.state.irData.wtax_fc1===undefined || this.state.irData.wtax_fc1==="" || this.state.irData.wtax_fc1===null)
                || (this.state.irData.wtax_fc2===undefined || this.state.irData.wtax_fc2==="" || this.state.irData.wtax_fc2===null))
            )
            {
                if(this.state.irData.wtax_fc1===undefined || this.state.irData.wtax_fc1==="" || this.state.irData.wtax_fc1===null)
                msgError+=("กรุณาระบุยอดเงิน W / tax base FC P1")+"<br/>"
                if(this.state.irData.wtax_fc2===undefined || this.state.irData.wtax_fc2==="" || this.state.irData.wtax_fc2===null)
                msgError+=("กรุณาระบุยอดเงิน W / tax base FC P2")+"<br/>"
            }
        }
        if(numeral(this.state.irBalance).format('0.00') !== '0.00' && role === "R"){
            msgError+=("กรุณาตรวจสอบยอดจำนวนเงินรวมภาษีมูลค่าเพิ่ม (Amount) อีกครั้ง")+"<br/>"
        }
        if(this.state.irData.invoice_date && this.state.irData.posting_date && new Date(this.state.irData.invoice_date.substring(0,10)) > new Date(this.state.irData.posting_date.substring(0,10))){
            msgError+=("Posting date ต้องมากกว่าหรือเท่ากับ Invoice date")+"<br/>"
        }
        if(role === "R" 
        && t_PO_DETAIL.vendor_code.indexOf("PXND")>=0 
        && t_IR_ONE_TIME_VENDOR 
        && (t_IR_ONE_TIME_VENDOR.ot_tax_number3 === null || t_IR_ONE_TIME_VENDOR.ot_tax_number3 === "" || t_IR_ONE_TIME_VENDOR.ot_tax_number3 === undefined)){
            msgError+=("Popup เพิ่มรายละเอียดข้อมูลผู้ค้า กรุณาระบุ เลขที่ประจำตัวผู้เสียภาษี")+"<br/>"
        }

        let dataValidate = this.state.irData
        Object.entries(this.modelIRDetail).forEach(([column,value]) => {
            if(!dataValidate.hasOwnProperty(column)){
                dataValidate[column]=null
            }
            
        })
        var listError=validateUtil.compareRequiredData('32',
        {
            "T_IR_DETAIL":dataValidate
        })
        
        if(Object.keys(listError).length >0 || msgError !=""){
            if(msgError !="")
            validateUtil.addListError(listError
                ,"T_IR_DETAIL"
                ,{error_message: msgError}
            )
            msg.warningSave(listError);
        }
        else
        {
            if (this.state.irData.running > 0) {
                const { t_IR_DETAIL } = this.props;
                const index = t_IR_DETAIL.findIndex((item) => {
                    return item.running == this.state.irData.running
                })
                t_IR_DETAIL[index] = this.state.irData
            } else {

                await this.setState({
                    irData: {
                        ...this.state.irData,
                        running: (this.props.t_IR_DETAIL.length + 1)
                    }
                })
                const { t_IR_DETAIL } = this.props;
                t_IR_DETAIL.push(this.state.irData)
            }
            if(this.state.irItem.length > 0){
                await this.state.irItem.map((element, index) =>{
                    if (element.running > 0) {
                        const { t_IR_ITEM } = this.props;
                        const index = t_IR_ITEM.findIndex((item) => {
                            return item.running == element.running
                        })
                        t_IR_ITEM[index] = element
            
                    } else {
            
                        element.running = (this.props.t_IR_ITEM.length + 1)

                        const { t_IR_ITEM } = this.props;
                        t_IR_ITEM.push(element)
                    }

                    if(element.checked && element.tax_code === this.state.irData.tax_type){
                        this.setState({
                            isTaxType:true
                        })
                    }
                });
            }
            if(this.state.irTax.length > 0){
                const { t_IR_TAXS } = this.props;
                // var elements = t_IR_TAXS.filter(f => f.ir_detail_id === this.state.irData.ir_detail_id);
                // for(var i = elements.length -1; i >= 0 ; i--){
                //     t_IR_TAXS.filter(f => f.ir_detail_id === this.state.irData.ir_detail_id).splice(0,);
                // }
                for(var i = t_IR_TAXS.length -1; i >= 0 ; i--){
                    if(t_IR_TAXS[i].ir_detail_id === this.state.irData.ir_detail_id)
                    t_IR_TAXS.splice(i,1)
                }
                await this.state.irTax.map((element, index) =>{
                    t_IR_TAXS.push(element)
                });
            }

            let _total = 0
            this.props.t_IR_ITEM.map((m, index)=>{
                if(m.checked === "1"){
                    _total += utilityHelper.parseFloat(m.amount)
                }
            })
            this.props.setSaveData();
            this.setState({
                openIR: false,
                totalWithoutVat: _total
            })        

            //msg.success("Save success")
        }
    }

    async handleDelete(index) {
        msg.showConfirm(
            "Confirm",
            MessageText.PAGE.IR.POPUP_MSG_CONFIRM_DELETE,
        ()=>{
           msg.hideConfirm()
           this.deleteIR(index) 
        },
        ()=>{
            msg.hideConfirm()
        },
        ()=>{
            //console.log("On Closed")
        }
        )
    }

    async deleteIR(index) {

        const { t_IR_DETAIL,t_IR_ITEM,t_IR_TAXS  } = this.props;

        let _irDelete = this.state.irDelete;
        _irDelete.push(t_IR_DETAIL[index])
        var id = t_IR_DETAIL[index].ir_detail_id

        for (var i = t_IR_ITEM.length - 1; i >= 0; --i) {
            if (t_IR_ITEM[i].ir_detail_id === id) {
                t_IR_ITEM.splice(i,1);
            }
        }
        for (var i = t_IR_TAXS.length - 1; i >= 0; --i) {
            if (t_IR_TAXS[i].ir_detail_id === id) {
                t_IR_TAXS.splice(i,1);
            }
        }
        t_IR_DETAIL.splice(index, 1);

        await this.setState({
            t_IR_DETAIL,
            irDelete:_irDelete
        })
        
        let _total = 0
        this.props.t_IR_ITEM.map((m, index)=>{
            if(m.checked === "1"){
                _total += utilityHelper.parseFloat(m.amount)
            }
        })
        await this.setState({
            openIR: false,
            totalWithoutVat: _total
        }) 
        msg.success(MessageText.PAGE.IR.POPUP_MSG_SUCCESS_DELETE)
        //this.props.updateTransaction(this.state.transaction)

    }

    checkValid(event) {
        return false;
    }

    createIRItem(detailId,t_PO_DETAIL,t_GR_ITEM,t_GR_SERVICE,t_GR_SERVICELINE){
        let _lsItm = []
        let _amount = 0
        t_GR_ITEM && t_GR_ITEM.map((item, index)=>{
            if(item.checked === "1"){
                let giAmount=item.receive_qty*item.net_price;
                if(item.per>1){
                    giAmount=item.receive_qty/item.per*item.net_price;
                }
                let _item={
                    transaction_no: item.transaction_no,
                    item_id: item.item_id,
                    checked: "1",
                    item_text: item.short_text,
                    order_unit: item.order_unit,
                    receive_qty: item.receive_qty,
                    tax_code: "",
                    amount: giAmount,
                    ir_detail_id: detailId,
                    service_based_flag:null,
                    gr_amount:item.receive_qty*item.net_price,
                    gr_receive_qty:item.receive_qty
                }
                _lsItm.push(_item)
                _amount += (item.receive_qty*item.net_price)
            }
        })
        t_GR_SERVICE && t_GR_SERVICE.map((item, index)=>{
            let itmLine = t_GR_SERVICELINE.filter(f=>f.service_item_no === item.service_item_no)                
            if(t_PO_DETAIL.service_based_flag){
                let check = false
                itmLine.map((itm, idx)=>{
                    if(itm.checked){
                        check = true
                        _amount += (itm.receive_qty*itm.gross_price)

                        let _item={
                            transaction_no: itm.transaction_no,
                            item_id: itm.service_item_no,
                            checked: "1",
                            item_text: itm.short_text,
                            order_unit: itm.unit,
                            receive_qty: itm.receive_qty,
                            tax_code: "",
                            amount: itm.receive_qty*itm.gross_price,
                            ir_detail_id: detailId,
                            line_no : itm.service_line_no,
                            service_based_flag:true,
                            gr_amount:itm.receive_qty*itm.gross_price,
                            gr_receive_qty:itm.receive_qty
                        }
                        _lsItm.push(_item)   
                    }
                })
            }else{

                if(item.checked === "1"){
                    let _itmAmount = 0
                    let _itmCount = 0
                    itmLine.map((itm, idx)=>{
                        if(itm.checked){
                            _itmAmount += (itm.receive_qty*itm.gross_price)
                            _itmCount += (itm.receive_qty)
                        }
                    })

                    _amount += (item.receive_qty*item.net_price)

                    let _item={
                        transaction_no: item.transaction_no,
                        item_id: item.service_item_id,
                        checked: "1",
                        item_text: item.short_text,
                        order_unit: item.order_unit,
                        receive_qty: "",
                        tax_code: "",
                        amount: _itmAmount,
                        ir_detail_id: detailId,
                        service_based_flag:false,
                        gr_amount:_itmAmount,
                        gr_receive_qty:null
                    }
                    _lsItm.push(_item)                
                }
            }
        })

        return _lsItm;
    }

    async createIR() {
        //console.log(this.props.with_code_p1s);
        const {t_MR_DETAIL,t_GR_DETAIL,t_GR_ITEM,t_GR_SERVICE,t_IR_DETAIL,t_PO_DETAIL,t_GR_SERVICELINE,t_IR_ITEM} = this.props

        let detailId = utilityHelper.genDateKey()
        let _lsItm = []
        const numeral = require('numeral');
        let checkall=true;
        _lsItm=this.createIRItem(detailId,t_PO_DETAIL,t_GR_ITEM,t_GR_SERVICE,t_GR_SERVICELINE)

        this.props.getWithCodeByVendor("","","",t_PO_DETAIL.vendor_code,"10",t_PO_DETAIL.pmt_method)
        .then((response)=>{
            
            this.setState({with_codes : response.data});
    })

        if(_lsItm && t_IR_ITEM.length>0){
            let sumItem=[];
            _lsItm.map((itm, idx)=>{
                var tranNo = itm.transaction_no
                var it_id = itm.item_id
                var line_no = itm.line_no
                var amount=0
                var rec_qty=0

                t_IR_ITEM.map((itm, idx)=>{
                    if(itm.transaction_no === tranNo && itm.item_id === it_id && itm.checked === "1"
                    && (itm.line_no === line_no || itm.line_no === null)){
                        amount += utilityHelper.parseFloat(itm.amount)
                        if(itm.receive_qty !=="")
                            rec_qty += utilityHelper.parseFloat(itm.receive_qty)
                    }
                })
                let gr_amount = itm.amount;
                let gr_qty = itm.receive_qty
                itm.amount=numeral(itm.amount-amount).format('0,0.00')
                if(itm.receive_qty!==""){
                    let cal_qty=itm.receive_qty-rec_qty
                    itm.receive_qty=numeral(cal_qty).format('0,0.000')
                    if(cal_qty != gr_qty && cal_qty> 0){
                        itm.amount = gr_amount / gr_qty * itm.receive_qty
                    }
                }

                if(itm.amount === "0.00" || itm.amount == 0){
                    itm.checked="0"
                    checkall=false;
                }

                return itm
            })
        }
        
        if(!_lsItm || _lsItm.length < 1){
            await this.setState({
                openIR: false
            })

            msg.error("กรุณาบันทึก ข้อมูล Goods Receipt หรือ เลือกรายการรับสินค้า")

            return ""
        }

        // if(t_IR_DETAIL.length>0)
        // {
        //     _amount = 0
        // }
        let days = 30
        //let _paytTerms = t_PO_DETAIL.vendor_code.match("PXND")? "V00C" : t_PO_DETAIL.payt_terms
        let _paytTerms = t_PO_DETAIL.payt_terms
        if(this.props.payment_terms && this.props.payment_terms.filter(f=>f.paymenT_TERM===_paytTerms).length>0){
            days = this.props.payment_terms.filter(f=>f.paymenT_TERM===_paytTerms)[0].daY_LIMIT
        }else{
            //_paytTerms = "C030"
            _paytTerms = ""
            days=""
        }

        const user=Storage.getUser()

        let _ir_text = t_GR_DETAIL.doc_text?t_GR_DETAIL.doc_text:_ir_text
        _ir_text = t_GR_DETAIL.po_header_text?t_GR_DETAIL.po_header_text:_ir_text

        _lsItm.map((itm, idx)=>{
            itm.amount = utilityHelper.parseFloat(numeral(itm.amount).format('0.00'))
            return itm
        })

        await this.setState({
            irBalance:0,
            checkall:checkall,
            valueTabs:0,
            openIR: true,
            irData: {
                //...this.state.irData,
                invoice_date: t_GR_DETAIL.document_date,
                posting_date: t_GR_DETAIL.post_date,
                currency: t_PO_DETAIL.currency,
                payt_terms: _paytTerms,
                pmt_method: t_PO_DETAIL.pmt_method,
                pmt_meth_sup: t_PO_DETAIL.pmt_meth_sup,
                exch_rate: numeral(t_PO_DETAIL.exch_rate).format('0,0.00000'),
                exch_rate_fixed: t_PO_DETAIL.exch_rate_fixed,
                //tax_type: "D7",
                ir_detail_id : detailId,
                amount:0,
                bus_place: user?user.busPlace:"",
                brach_code: "00000",
                payt_term_days: days,
                reference: t_GR_DETAIL.delivery_note?t_GR_DETAIL.delivery_note:t_GR_DETAIL.reference,
                invoicing_party: t_PO_DETAIL.vendor_code,
                vendor_code :t_PO_DETAIL.vendor_code,
                vendor_name:t_PO_DETAIL.vendor_code + " " + t_PO_DETAIL.vendor_name,
                calculate_tax_flag:1,
                tax_amount:0,
                ir_text: _ir_text,
                baseline_date:t_MR_DETAIL.mom_date, 
            },
            //...this.state.irItem,
            irItem: _lsItm,
            irTax:[]
        })
        $(function () {
            window.onComponentDidMount();
        })
            this.calBalance()
        return ""
    }

    async setEditIR(index){
        let checkall=true;

        var {t_PO_DETAIL} = this.props;

        
        this.props.getWithCodeByVendor("","","",t_PO_DETAIL.vendor_code,"10",t_PO_DETAIL.pmt_method)
        .then((response)=>{
            
            this.setState({with_codes : response.data});
    })

        const numeral = require('numeral');
        if(this.props.t_IR_ITEM.filter(f=>f.ir_detail_id === this.props.t_IR_DETAIL[index].ir_detail_id && f.checked !== "1").length>=1)
            checkall=false;
        let irTax = this.props.t_IR_TAXS ? this.props.t_IR_TAXS.filter(f=>f.ir_detail_id === this.props.t_IR_DETAIL[index].ir_detail_id) :[];
        for (let i = 0; i < irTax.length; i++) {
            if(irTax[i].tax_code){
                irTax[i].tax_code_name = this.props.masterVats.find(f=>f.value === irTax[i].tax_code)?this.props.masterVats.find(f=>f.value === irTax[i].tax_code).display:0
                irTax[i].base_amount = irTax[i].base_amount ? numeral(irTax[i].base_amount).format('0,0.00'):0
                irTax[i].tax_doc_currency = irTax[i].tax_doc_currency ? numeral(irTax[i].tax_doc_currency).format('0,0.00'):0
            }
        }
        let irDetail=this.props.t_IR_DETAIL[index]
        if(irDetail.exch_rate_fixed === "True")
        {
            irDetail.exch_rate_fixed="1"
        }

        

        await this.setState({
            checkall:checkall,
            openIR: true,
            //...this.state.irData,
            irData: irDetail,
            //...this.state.irItem,
            irItem: this.props.t_IR_ITEM.filter(f=>f.ir_detail_id === this.props.t_IR_DETAIL[index].ir_detail_id),
            irTax : irTax,
            valueTabs:0,
        })
        await this.calBalance();
        $(function () {
            window.onComponentDidMount();
        })
        
        
        return ""
    }

    goBack() {

        this.props.setSaveData();

        this.setState({
            openIR: false
        })
        $(function () {
            window.onComponentDidMount()
        })
        return ""
    }

    setDueDate(){ 
        
    }

    handleChange(event) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        const numeral = require('numeral');
        this.props.setChangeData();

        if ((value.toString()).indexOf("/") > 0 && (value.toString().match(/\//g) || []).length === 2 && target.className.indexOf("js-datepicker") > -1) {
            if (moment(value, 'DD/MM/YYYY').isValid()) {
                value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
        }            
          
        if (valid) {
            let _data = {
                ...this.state
            }
    
            _data.irData= {
                ..._data.irData,
                [name]: value
            }
  
            if(name == "pmt_method")
            {
                let {
                    irData
                } = this.state
                var {t_PO_DETAIL} = this.props;
                
                this.props.getWithCodeByVendor("","","",t_PO_DETAIL.vendor_code,"10",value)
                .then((response)=>{
                    
                    this.setState({with_codes : response.data});

            })
            }

            if(name === "payt_terms"){
                let days = this.props.payment_terms && this.props.payment_terms.filter(f=>f.paymenT_TERM===_data.irData.payt_terms).length>0?this.props.payment_terms.filter(f=>f.paymenT_TERM===_data.irData.payt_terms)[0].daY_LIMIT:""
                var due_date = _data.irData.due_date

                if(_data.irData.baseline_date && days){
                    due_date = new Date(_data.irData.baseline_date);
                    due_date.setDate(due_date.getDate() + parseInt(days))
                    due_date=moment(due_date).format('DD/MM/YYYY')
                }
                else
                    due_date=""

                if(days==="")
                    due_date = ""

                if(_data.irData.baseline_date && _data.irData.payt_terms==="C000"){
                    due_date = new Date(_data.irData.baseline_date);
                    days="0";
                    due_date=moment(due_date).format('DD/MM/YYYY')
                }

                _data.irData ={
                    ..._data.irData,
                    payt_term_days: days,
                    due_date:due_date
                }
            }
            else if(name === "tax_type"){
                let tax = 0
                _data.irItem.map((element, index) =>{
                 
                    if(element.checked === "1"){
                        let vat = this.props.masterVats.filter(f=>f.value === value).length>0?this.props.masterVats.filter(f=>f.value === value)[0].key1:0
                        let t = (utilityHelper.parseFloat(numeral(element.amount).format('0,0.00'))*utilityHelper.parseFloat(vat))                        
                        tax += t
                    }
                })
 
                _data.irData ={
                    ..._data.irData,
                    tax_amount: tax
                }
                _data.irItem = _data.irItem.map((data, index)=>{
                    let updateItem = data
                    updateItem["tax_code"] = value
                    return updateItem
                })
         
            }
            else if(name === "payt_term_days" || name === "baseline_date"){
                var due_date = ""
                let payt_term_days = _data.irData.payt_term_days;
                let baseline_date = _data.irData.baseline_date;

                if (name === "payt_term_days" )
                    payt_term_days=value
                if (name === "baseline_date" )
                    baseline_date=value

                if(baseline_date && payt_term_days){
                    due_date = new Date(baseline_date);
                    due_date.setDate(due_date.getDate() + parseInt(payt_term_days))
                    due_date=moment(due_date).format('DD/MM/YYYY')
                }
                let days = this.props.payment_terms && this.props.payment_terms.filter(f=>f.paymenT_TERM===_data.irData.payt_terms).length>0?this.props.payment_terms.filter(f=>f.paymenT_TERM===_data.irData.payt_terms)[0].daY_LIMIT:""
                
                if(_data.irData.payt_terms === "C000")
                    days=0;
                
                if(days==="")
                    due_date = ""
                    
                _data.irData ={
                    ..._data.irData,
                    due_date: due_date
                }
            }
            else if(name === "wtax_code1"){
                if(value === ""){
                    _data.irData ={
                        ..._data.irData,
                        wtax_fc1: "",
                        wtax_code1:"",
                        wtax_code2:"",
                        wtax_fc2: ""
                    }
                }
            }
            else if(name === "calculate_tax_flag" && value === 1){
                _data ={
                    ..._data,
                    //valueTabs:0,
                    irTax:[],
                    irData: {
                        ..._data.irData,
                        edit_tax_head:0,
                        edit_tax_item:0
                    }
                }
            }
            else if(name === "tax_amount"){
                _data.irData ={
                    ..._data.irData,
                    edit_tax_head:1,
                    edit_tax_item:0
                }
            }
            else if(name === "reference"){
                value = value.trimStart().trimEnd();
                _data.irData ={
                    ..._data.irData,
                    reference:value
                }
            }

            if(
                name === "tax_amount" || name === "calculate_tax_flag" || name === "tax_type" || 
                name === "amount" 
            ){
                _data=this.calBalance(_data)
            }
            
            this.setState({
                ..._data 
            });

            if(name === "wtax_code1"){
                window.$('#wtax_fc1').val('')
                window.$('#wtax_fc2').val('')
            }
            else if (name === "reference"){
                window.$('#receiver_name').val(value)
            }
            window.$('#tax_amount').val(numeral(_data.irData.tax_amount).format('0,0.00'))


        } else {

            return
        }
    }
    
    async handleClick(_event, index, listName, selectedName) {
        
        let _data = {
            ...this.state
        }
        
        const isChecked = _data.irItem[index].checked;

        if (isChecked === "" || isChecked === "0") {
            _data.irItem[index].checked = "1"          
        } else {
            _data.irItem[index].checked = "0"           
        }

        let _checkAll = true
        await _data.irItem && _data.irItem.map((m)=>{
            if(m.checked !== "1"){
                _checkAll=false
            }
        })

        _data.checkall=_checkAll
        _data = {
            ..._data,
            irData: {
                ...this.state.irData,
                edit_tax_head:0,
                edit_tax_item:0
            }
        }

        _data=this.calBalance(_data)

        this.setState({
            ..._data 
        });
    }

    async handleChangeItem(event, index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        const numeral = require('numeral');

        this.props.setChangeData();
        if ((value.toString()).indexOf("/") > 0) {
            if (moment(value, 'DD/MM/YYYY').isValid()) {
                value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
        }
        
        let { start}  = this.state
        start = event.target.selectionStart

        if (valid) {
            let _data = {
                ...this.state
            }

            _data.irItem=this.state.irItem.map((data, i) =>{
                if(index === i){
                    let updateItem = data
                    updateItem[name] = value
                    return updateItem
                }else{
                    return data
                }
            })
            if(name === "tax_code" || name === "amount"){
                _data.irData ={
                    ...this.state.irData,
                    edit_tax_head:0,
                    edit_tax_item:0,
                }
            }
            _data=this.calBalance(_data)
            
            this.setState({
                ..._data 
            });

        } else {
            return
        }
    }

    async handleChangeItemTax(event, index) {
        const numeral = require('numeral');
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
 
        let _data = {
            ...this.state
        }

        _data = {
            ..._data,
            irTax: this.state.irTax.map((data, i) =>{
                if(index === i){
                    let updateItem = data
                    updateItem[name] = value
                    return updateItem
                }else{
                    return data
                }
            }),
            irData: {
                ...this.state.irData,
                edit_tax_head:0,
                edit_tax_item:1
            }
        }
        
        _data=this.calBalance(_data)

        this.setState({
            ..._data 
        });
    }

    async handleExchRateChange(event){
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.value;
        const name = target.name;
        if ((value.toString()).indexOf("/") > 0) {
            if (moment(value, 'DD/MM/YYYY').isValid()) {
                value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
        }
        
        if (valid && value !== "") {
        await this.setState({
                irData: {
                    ...this.state.irData,
                    [name]: value
                }
            });
        } else {
            return
        }

        // await this.props.getExchangeRate(1,this.props.t_PO_DETAIL.currency,this.state.irData.currency,this.state.irData.exch_rate_date)
        // .then(response => {
        //     let exch = ""
        //     if(response.data.length > 0){
        //         exch = response.data[0].eX_RATE
        //     }
        //     const numeral = require('numeral');
        //     this.setState({
        //         irData:{
        //             ...this.state.irData,
        //             exch_rate:numeral(exch).format('0,0.00000')
        //         }
        //     })
        // });
    }
    
    async handleInvoicingPartyChange(event){
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.value;
        const name = target.name;
                
        if (valid && value !== "") {        

            await this.props.getVendorInformation(value)
            .then(response => {
                if(response.data !== null){
                    this.setState({
                        irData: {
                            ...this.state.irData,
                            [name]: value
                        }
                    });
                }else{
                    msg.error("ไม่สามารถเลือกใช้ Vendor นี้ได้")
                    this.setState({
                        irData: {
                            ...this.state.irData,
                            [name]: ""
                        }
                    });
                }
            });
        } else {
            return
        }
    }

    calBalance(_data){

        if(!_data)
            _data=this.state


        let cal = 0
        let tax = 0
        let sum = 0
        let numeral = require('numeral');
        let tran_no = null;
        let detailId = null
        let list_vat=new Object();
        let irTax=[]
        _data.irItem.map((element, index) =>{
            detailId = element.ir_detail_id
            tran_no = element.transaction_no

            if(element.checked === "1"){
                let vat = this.props.masterVats.find(f=>f.value === element.tax_code)?this.props.masterVats.find(f=>f.value === element.tax_code).key1:0
                let t = _data.irData.calculate_tax_flag === 1?(utilityHelper.parseFloat(numeral(element.amount).format('0,0.00'))*utilityHelper.parseFloat(vat)):0
                sum += utilityHelper.parseFloat(numeral(element.amount).format('0,0.00')) + t

                let taxItem = (utilityHelper.parseFloat(numeral(element.amount).format('0,0.00'))*utilityHelper.parseFloat(vat))
                tax+=taxItem
                let taxGroup = list_vat[element.tax_code] !== undefined ? 
                [
                    utilityHelper.parseFloat(list_vat[element.tax_code][0])
                    ,utilityHelper.parseFloat(list_vat[element.tax_code][1])
                ]
                : [0,0]
                list_vat[element.tax_code] = 
                [
                    taxGroup[0] + (taxItem)
                    ,taxGroup[1] + utilityHelper.parseFloat(numeral(element.amount).format('0,0.00'))
                ]

            }
        })
        Object.entries(list_vat).forEach(([key, value]) => {
            let tax_name = this.props.masterVats.find(f=>f.value === key)?this.props.masterVats.find(f=>f.value === key).display:""
            if(tax_name !== "")
            irTax.push({
                "tax_code":key,
                "tax_code_name":tax_name,
                "tax_doc_currency":numeral(value[0]).format('0,0.00'),
                "base_amount":_data.irTax.find(f=>f.base_amount === key)?_data.irTax.find(f=>f.base_amount === key).last().base_amount:numeral(value[1]).format('0,0.00'),
                "ir_detail_id":detailId,
                "transaction_no":tran_no
            })
        })

        let am = utilityHelper.parseFloat(_data.irData.amount)
        let ta = utilityHelper.parseFloat(_data.irData.tax_amount)
        if(_data.irData.calculate_tax_flag === 1){
            ta = 0
        }

        if(_data.irData.calculate_tax_flag !== undefined && _data.irData.calculate_tax_flag === 0 )
        {
            if(_data.irData.edit_tax_head!== undefined && _data.irData.edit_tax_head===1){//แก้ Tab Head
                tax=_data.irData.tax_amount
                if(irTax && irTax.length > 0 && irTax[0] !== null){
                    irTax[0].tax_doc_currency=utilityHelper.parseFloat(numeral(tax).format('0,0.00'));
                }
            }
            else if(_data.irData.edit_tax_item === 1)//แก้ Item
            {
                irTax=_data.irTax
                let sum=0;
                _data.irTax.map((element, index) =>{
                    sum+=utilityHelper.parseFloat(numeral(
                        utilityHelper.parseFloat(element.tax_doc_currency)
                        ).format('0,0.00'))
                });
                ta=sum
                tax=sum
            }
            else if (_data.irData.edit_tax_item === 0 && _data.irData.edit_tax_head === 0){
                ta=tax;
            }
        }

        sum = utilityHelper.parseFloat(numeral(sum+ta).format('0,0.00'))
        cal = numeral(am - sum).format('0,0.00')
        tax = utilityHelper.parseFloat(numeral(tax).format('0,0.00'))
        
        
        _data={
            ..._data,
            irBalance: cal,
            irData: {
                ..._data.irData,
                tax_amount: tax
            },
            irTax:irTax
        }        
        window.$('#tax_amount').val(numeral(tax).format('0,0.00'))
        return _data;
    }
    
    handleDecimalBlur(event) {
        const target = event.target;
        //console.log(target)
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        const numeral = require('numeral');

        let { start,floatingPoint}  = this.state
        start = event.target.selectionStart
        //console.log(event.target.inputMode)
        //if((event.target.inputMode && event.target.inputMode === "decimal") || event.target.alt === "decimal"){
            if(value.length > 0){
                event.target.value = numeral(value).format(event.target.step);
                start = start + (event.target.value.length - value.length)
                //event.target.setSelectionRange(start, start);
            }
            this.setState({
                irData: {
                    ...this.state.irData,
                    [name]: value
                }
            });

        //}        

    }
    
    handleDecimalItemBlur(event,index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        const numeral = require('numeral');

        let { start,floatingPoint}  = this.state
        start = event.target.selectionStart
        //if(event.target.inputMode === "decimal"){
            event.target.value = numeral(value).format(event.target.step);
            start = start + (event.target.value.length - value.length)
            //event.target.setSelectionRange(start, start);
            this.setState({
               ...this.state.irItem,
               irItem: this.state.irItem.map((data, i) =>{
                   if(index === i){
                       let updateItem = data
                       updateItem[name] = value
                       return updateItem
                   }else{
                       return data
                   }
               })
           });
        //}       

    }

    handleDecimalItemTaxBlur(event,index) {
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;
        const numeral = require('numeral');

        let { start,floatingPoint}  = this.state
        start = event.target.selectionStart
        //if(event.target.inputMode === "decimal"){
            event.target.value = numeral(value).format(event.target.step);
            value = event.target.value
            start = start + (event.target.value.length - value.length)
            //event.target.setSelectionRange(start, start);
            this.setState({
               ...this.state.irTax,
               irTax: this.state.irTax.map((data, i) =>{
                   if(index === i){
                       let updateItem = data
                       updateItem[name] = value
                       return updateItem
                   }else{
                       return data
                   }
               })
           });
        //}       

    }

    async handleSelectAllClick(event){
        const target = event.target;
        let value = target.checked
        let value1 = target.checked ? "1" : "0"

        let _data = {
            ...this.state
        }

        _data = {
            ..._data,
            irData: {
                ...this.state.irData,
                edit_tax_head:0,
                edit_tax_item:0
            },
            irItem: this.state.irItem.map((data, i) =>{                
                let updateItem = data
                updateItem["checked"] = value1
                return updateItem
            }),
            checkall:value
        }
        
        _data=this.calBalance(_data)

        this.setState({
            ..._data 
        });
    }
    render() {
        // console.log("InvoiceReceive.render()")
        const {
            t_IR_DETAIL,
            t_PO_DETAIL,
            t_IR_ONE_TIME_VENDOR,
            viewMode,
            regions,
        } = this.props

        let {
            irData,
            business_places,
            with_codes,
            checkall,
        } = this.state

        let role=Storage.getRole()

        const numeral = require('numeral');
        const handleChangeTabs = (event, newValue) => {
            this.setState({
                valueTabs:newValue  
            })
        };
          
        function AntTabProps(index) {
            return {
                id: `scrollable-auto-tab-${index}`,
                'aria-controls': `scrollable-auto-tabpanel-${index}`,
            };
        }
        const AntTab = withStyles(theme => ({
            root: {
              textTransform: 'none',
              minWidth: 72,
              fontSize:19,
              fontWeight: theme.typography.fontWeightRegular,
              marginRight: theme.spacing(4),
              fontFamily: [
                'inherit',
              ].join(','),
              '&:hover': {
                color: '#40a9ff',
                opacity: 1,
              },
              '&$selected': {
                color: '#0072bc',
                fontWeight: theme.typography.fontWeightMedium,
              },
              '&:focus': {
                color: '#40a9ff',
              },
            },
            selected: {},
          }))(props => <Tab disableRipple {...props} />);

        return (
            <div className="rrs-container-wrap collapse" id="rrsTab4" aria-labelledby="rrsInvoiceReceive" data-parent="#invoiceRecordingSystem">
                {!this.state.openIR && (<div className="rrs-container">
                    <div className="rrs-detail">
                        <div className="sp-table-container">
                            <div className="row rrs-table-hdr-wrap">
                                <div className="col"><h2 className="rrs-table-hdr">Invoice Receipt</h2></div>
                            </div>
                            <Div className="row sp-pagination-control-top" viewMode={viewMode}>
                                <div className="col-auto create-button">
                                    <a className="sp-bt-addmore" onClick={() => this.createIR()}>
                                        <i className="icon btn-plus" />
                                        <span>เพิ่ม</span>
                                    </a>
                                </div>
                            </Div>
                            <div className="row no-gutters sp-table-content">
                                <table className="sp-table table rrs-table">
                                    <thead>
                                        <tr className="sp-table-header">
                                            {viewMode === false && (
                                            <React.Fragment>
                                               
                                            <th className="th-table text-center"><div className="th-text">Delete</div></th>
                                            </React.Fragment>)
                                            }                                       
                                            <th className="th-table text-center"><div className="th-text">Detail</div></th>
                                            <th className="th-table"><div className="th-text">Invoice No.</div></th>
                                            <th className="th-table"><div className="th-text">Invoice Date</div></th>
                                            <th className="th-table"><div className="th-text">Amount</div></th>
                                            <th className="th-table"><div className="th-text">Currency</div></th>
                                            <th className="th-table"><div className="th-text">Bus.place/sectn</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {t_IR_DETAIL && t_IR_DETAIL.map((item, index) => (
                                            <tr key={(index + 1)}>
                                           {viewMode === false && (
                                            <React.Fragment>
                                                <td className="text-center">
                                                    <a className="clickable" onClick={() => this.handleDelete(index)}>
                                                        <i className="icon btn-trash" />
                                                    </a>
                                                </td>  
                                           </React.Fragment>)
                                            }                                                                                               
                                                <td className="text-center">
                                                    <a className="mr-3 clickable" onClick={() => this.setEditIR(index)}>
                                                        <i className="icon bt-edit" />
                                                    </a>
                                                </td>                                               
                                                <td>{item.reference}</td>
                                                <td>{item.invoice_date ? moment(item.invoice_date).format('DD/MM/YYYY') : ""}</td>
                                                <td>{numeral(item.amount).format('0,0.00')}</td>
                                                <td>{item.currency}</td>
                                                <td>{item.bus_place}</td>
                                            </tr>))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="sp-table-container">
                            <div className="row">
                                <div className="offset-sm-8 col-sm-4 sp-pagination-control-top text-right">
                                    <div className="col-auto create-button text-right">
                                        <label style={{fontSize:16}}>Total Without VAT = {numeral(this.state.totalWithoutVat).format('0,0.00')}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row sp-table-content-footer">
                            <div className="col-12 sp-header-button-panel2 justify-content-center" style={{ visibility: viewMode ? "hidden" : "visible" }}>
                                {t_PO_DETAIL.transaction_no !== null && (
                                    <a className="sp-btn-icon" onClick={ () => { this.props.onHandleDelete("Transaction") } }>
                                        <i className="icon btn-order-delete" />
                                        <span className="sp-btn-icon-label2">Delete</span>
                                    </a>
                                )}
                                {t_PO_DETAIL.po_contract_no != null && (
                                    <a href="#main" className="sp-btn-icon btn-save-draft" onClick={(e) => { this.props.onHandleSubmit(e, this, null, null, "rrsTab5") }}>
                                        <i className="icon btn-order-savedraft" />
                                        <span className="sp-btn-icon-label">Save</span>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                )}
                {this.state.openIR && (<div className="rrs-container">
                    {t_PO_DETAIL.po_contract_no && (<div className="rrs-detail pt-1 pb-3">
                        <div className="row">
                            <div className="col-md-4">
                                <h4>PO / Contract No. {t_PO_DETAIL.po_contract_no}</h4>
                            </div>
                            <div className="col-md-8 text-right">
                                <h4>Vendor : {t_PO_DETAIL.vendor_code + " " + t_PO_DETAIL.vendor_name}</h4>
                                
                            </div>
                        </div>
                        {t_PO_DETAIL.vendor_code.indexOf("PXND")>=0 && t_IR_ONE_TIME_VENDOR &&
                        <div className="row">                            
                            <div className="col-md-12 text-right" style={{fontSize:13}}>
                                {t_IR_ONE_TIME_VENDOR.ot_name1 ? t_IR_ONE_TIME_VENDOR.ot_name1 : ""}
                                {t_IR_ONE_TIME_VENDOR.ot_name2 ? " "+t_IR_ONE_TIME_VENDOR.ot_name2 : ""}
                                {t_IR_ONE_TIME_VENDOR.ot_name3 ? " "+t_IR_ONE_TIME_VENDOR.ot_name3 : ""}
                                {t_IR_ONE_TIME_VENDOR.ot_name4 ? " "+t_IR_ONE_TIME_VENDOR.ot_name4 : ""}

                            </div>  
                            <div className="col-md-12 text-right" style={{fontSize:13}}>
                                {t_IR_ONE_TIME_VENDOR.ot_street ? t_IR_ONE_TIME_VENDOR.ot_street +" " : ""}
                                {t_IR_ONE_TIME_VENDOR.ot_city ? t_IR_ONE_TIME_VENDOR.ot_city +" " : ""}
                            </div>  
                            <div className="col-md-12 text-right" style={{fontSize:13}}>
                                {t_IR_ONE_TIME_VENDOR.ot_region ? t_IR_ONE_TIME_VENDOR.ot_region +" " : ""}
                                {regions.find(f=>f.value === t_IR_ONE_TIME_VENDOR.ot_region) && regions.find(f=>f.value === t_IR_ONE_TIME_VENDOR.ot_region).display} &nbsp;
                                {t_IR_ONE_TIME_VENDOR.ot_postal_code ? t_IR_ONE_TIME_VENDOR.ot_postal_code +" " : ""}
                            </div>                    
                        </div>
                        }

                        <div className="row">
                            {t_IR_ONE_TIME_VENDOR.ot_bank_account && (
                            <div className="col-md-12 text-right" style={{fontSize:13}}>
                                Bank Info. : Bank acct. 
                                {t_IR_ONE_TIME_VENDOR.ot_bank_account} &nbsp;
                                {t_IR_ONE_TIME_VENDOR.ot_bank_name}
                            </div>
                            )}
                        </div>
                        
                        {t_PO_DETAIL.vendor_code.indexOf("PXND")>=0 && 
                        
                        <div className="row">
                            <div className="offset-sm-10 sp-pagination-control-top text-right" style={{marginLeft:"86%",paddingTop:5}}>
                                <div className="col-auto create-button text-right">
                                    <a href="#main" className="sp-bt-addmore" style={{marginLeft:-42}} onClick={() => this.props.updateIR_OneTimeVendor(t_IR_ONE_TIME_VENDOR)} data-toggle="modal" data-target="#oneTimeVendorModal">
                                        <i className="icon btn-plus" />
                                        <span>เพิ่มรายละเอียดข้อมูลผู้ค้า</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        }
                    </div>)}
                    <div className="rrs-detail py-1">
                        <div className="row">
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="cc" id="lbl-ir_header_invoice_date" className="rrs-label mb-0"><span className="required">*</span> Invoice Date</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-ir_header_invoice_date" className="rrs-label"> (วันที่ใบแจ้งหนี้/ใบกำกับภาษี)</label>
                                    </div>

                                    <div className="rrs-detail-data">
                                        <Input
                                            tagid="ir.header.invoice_date"
                                            doctype={"*"}
                                            type="text"
                                            className="form-control js-datepicker ir-invoice-date"
                                            defaultValue={irData.invoice_date
                                                ? moment(irData.invoice_date).format('DD/MM/YYYY')
                                                : ""}
                                            name="invoice_date"
                                            id="currency_exchange_date"
                                            onChange={this.handleChange}
                                            onBlur={this.handleChange}
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            autoComplete="off"
                                            maxLength="15" 
                                            viewMode={viewMode}
                                            />

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="cc" id="lbl-ir_header_reference" className="rrs-label mb-0"><span className="required">*</span> Reference</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-ir_header_reference" className="rrs-label"> (เลขที่ใบแจ้งหนี้/ใบกำกับภาษี)</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <Input
                                            tagid="ir.header.reference"
                                            doctype={"*"}
                                            type="text"
                                            name="reference"
                                            defaultValue={irData.reference}
                                            // className="form-control form-control-search-2 ir-reference"
                                            className="form-control ir-reference"
                                            autoComplete="off"
                                            id="receiver_name"
                                            onBlur={this.handleChange}
                                            maxLength="16"
                                            viewMode={viewMode}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="cc" id="lbl-ir_header_posting_date" className="rrs-label mb-0"> Posting Date</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-ir_header_posting_date" className="rrs-label"> (วันที่หน่วยงานจัดการบันทึกข้อมูล IR)</label>
                                    </div>

                                    <div className="rrs-detail-data">
                                        <DatePicker
                                            tagid="ir.header.posting_date"
                                            doctype={"*"}
                                            type="text"
                                            className="form-control js-datepicker ir-posting-date"
                                            defaultValue={irData.posting_date
                                                ? moment(irData.posting_date).format('DD/MM/YYYY')
                                                : ""}
                                            name="posting_date"
                                            id="penalty_doc_date"
                                            onChange={this.handleChange}
                                            onBlur={this.handleChange}
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy"
                                            viewMode={viewMode}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <div className="rrs-form">
                                        <p style={{marginBottom:0}} ref={ref => this.docFrom = ref} data-tip='
                                                วันที่ ปตท. ได้รับมอบและตรวจรับถูกต้องครบถ้วนตามสัญญาหรือใบสั่งซื้อ/จ้าง/เช่า 
                                                <br/>และ ปตท. ได้รับหลักฐานการขอรับชำระหนี้ถูกต้องเรียบร้อยแล้ว
                                                '></p>
                                        <label htmlFor="cc" id="lbl-ir_header_baseline_date" className="rrs-label">BaselineDT</label>
                                        <div className="icon-info"
                                                onMouseOver={() => { ReactTooltip.show(this.docFrom) }}
                                                onMouseLeave={() => { ReactTooltip.hide(this.docFrom) }}></div>
                                            <ReactTooltip html={true} />
                                        <div className="rrs-detail-data">
                                            <DatePicker
                                                tagid="ir.header.baseline_date"
                                                doctype={"*"}
                                                type="text"
                                                className="form-control js-datepicker ir-baseline_date"
                                                defaultValue={irData.baseline_date
                                                    ? moment(irData.baseline_date).format('DD/MM/YYYY')
                                                    : ""}name="baseline_date"
                                                id="ir_baseline_date"
                                                onChange={this.handleChange}
                                                onBlur={this.handleChange}
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                viewMode={viewMode}
                                                />
                                                
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="cc" id="lbl-ir_header_payt_terms" className="rrs-label"> Payt Terms</label>
                                    <div className="rrs-detail-data">
                                        <div className="d-flex">
                                            {/* <Input
                                                type="text"
                                                name="payt_terms"
                                                value={this.state.irData.payt_terms}
                                                className="form-control ir-payt_terms"
                                                id="this.state.irData.payt_terms"
                                                onChange={this.handleChange}
                                            /> */}
                                            <Select
                                                tagid="ir.header.payt_terms"
                                                doctype={"*"}
                                                className="form-control col-sm-7 ir-payt_terms"
                                                name="payt_terms"
                                                defaultValue={irData.payt_terms}
                                                onChange={this.handleChange}
                                                viewMode={viewMode}
                                            >
                                            <option></option>
                                            {
                                                t_PO_DETAIL && t_PO_DETAIL.vendor_code && t_PO_DETAIL.vendor_code.indexOf("PXND")<0 && 
                                                (<option value="C000">C000 ชำระทันที</option>)
                                            }
                                            {this.props.payment_terms && t_PO_DETAIL.vendor_code && this.props.payment_terms.map((data, index) => (
                                                 (data.accT_TYPE === "K" || data.paymenT_TERM === 'C000')
                                                 && ((t_PO_DETAIL.vendor_code.match("PXND") && (data.paymenT_TERM && data.paymenT_TERM.match("V")))
                                                 || t_PO_DETAIL.vendor_code.indexOf("PXND")<0) && (
                                                    <option
                                                        key={index}
                                                        value={data.paymenT_TERM}>
                                                        {data.paymenT_TERM + " " + data.desC_TH}
                                                    </option>
                                                )
                                            ))}
                                            </Select>
                                            
                                            <label htmlFor="cc" className="rrs-label rrs-label-margin-top10"> Days </label>
                                            <Input
                                                type="text"
                                                name="payt_term_days"
                                                // value={this.state.irData.payt_terms_day}
                                                value={irData.payt_term_days}
                                                className="form-control col-sm-3 ir-payt_term_days"
                                                id="this.state.irData.payt_term_days"
                                                onChange={this.handleChange}
                                                pattern="[0-9]*"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <div className="rrs-form">
                                        <label htmlFor="cc" id="lbl-ir_header_due_date" className="rrs-label">Due Date</label>
                                        <div className="rrs-detail-data">
                                            <Input
                                                disabled="disabled"
                                                // doctype={"*"}
                                                type="text"
                                                // value={irData.due_date}
                                                className="form-control js-datepicker-all ir-due_date"
                                                defaultValue={
                                                    irData.payt_term_days && irData.baseline_date
                                                    ? moment(
                                                        new Date(irData.baseline_date)
                                                        .setDate(
                                                            new Date(irData.baseline_date).getDate()
                                                            +parseInt(irData.payt_term_days)
                                                        ) 
                                                     ).format('DD/MM/YYYY')
                                                    : ""}
                                                name="due_date"
                                                id="this.state.irData.due_date"
                                                value={irData.due_date}
                                                // onChange={this.handleChange}
                                                // onBlur={this.handleChange}
                                                placeholder="dd/mm/yyyy"
                                                data-date-format="dd/mm/yyyy"
                                                viewMode={viewMode}
                                                />
                                                
                                        </div>
                                    </div>
                                </div>
                            </div>
                                                                                    
                        </div>
                        <div className="row">
                        <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="cc" id="lbl-ir_header_ir_textTemp" className="rrs-label mb-0">{role === "R" && <span className="required">* </span>}Text </label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-ir_header_ir_text" className="rrs-label"> (รายละเอียดงวดงาน/ชื่องาน)</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <Input
                                            tagid="ir.header.ir_text"
                                            doctype={"*"}
                                            type="text"
                                            name="ir_text"
                                            defaultValue={irData.ir_text}
                                            className="form-control ir_text"
                                            id="this.state.irData.ir_text"
                                            onBlur={this.handleChange}
                                            maxLength="50"
                                            viewMode={viewMode}
                                        />
                                    </div>
                                </div>
                                
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="cc" id="lbl-ir_header_amount" className="rrs-label mb-0"> Amount</label>
                                    <div className="rrs-detail-data">
                                    <div className="d-flex">
                                        <label htmlFor="cc" id="lblsub-ir_header_amount" className="rrs-label"> (จำนวนเงินรวมภาษีมูลค่าเพิ่ม)</label>
                                        <label  className="checkboxcontainer rrs-fine-label margin-left10 ir-calculate_tax_flag">Calculate Tax
                                            <input disabled={viewMode?"disabled":""}
                                                checked={irData.calculate_tax_flag === 1 && !irData.edit_tax_item}
                                                type="checkbox"
                                                name="calculate_tax_flag"
                                                id="calculate_tax_flag"
                                                value={irData.calculate_tax_flag}
                                                onChange={this.handleChange}
                                            />
                                            <span className="form-control-gra checkboxmark chm-ir-calculate_tax_flag" />
                                        </label>
                                    </div>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="d-flex">
                                            <InputDecimal
                                                tagid="ir.header.amount"
                                                doctype={"*"}
                                                type="text"
                                                name="amount"
                                                pattern="[0-9.,]*"
                                                defaultValue={numeral(irData.amount).format('0,0.00')}
                                                className="form-control col-sm-8 mr-3 ir-amount"
                                                id="amount"
                                                onChange={(event) => this.handleChange(event)}
                                                onPaste={this.handleChange}
                                                onBlur={this.handleDecimalBlur}
                                                inputMode="decimal"
                                                alt="decimal"
                                                step="0,0.00"
                                                viewMode={viewMode}
                                            />
                                             
                                             <Select
                                                tagid="ir.header.amount_cu"
                                                doctype={"*"}
                                                className="form-control col-sm-4 ir-currency"
                                                name="currency"
                                                defaultValue={irData.currency}
                                                onChange={this.handleChange}
                                                viewMode={viewMode}
                                            >
                                            {this.props.currency_codes && this.props.currency_codes.map((data, index) => (
                                                 data.language === "E" && (
                                                    <option
                                                        key={index}
                                                        value={data.currencY_CODE}>
                                                        {data.currencY_CODE}
                                                    </option>
                                                )
                                            ))}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <div className="rrs-detail-data content-hide">
                                        <label htmlFor="cc" id="lblsub-ir_header_ir_balance" className="rrs-label">|</label>
                                    </div>
                                    <label htmlFor="cc" id="lbl-ir_header_ir_balance" className="rrs-label mb-0">IR Balance</label>
                                    <div className="rrs-detail-data">
                                        <div className="d-flex">
                                            <Input disabled="disabled"
                                                type="text"
                                                name="balance"
                                                pattern="[0-9]*"
                                                value={numeral(utilityHelper.parseFloat(this.state.irBalance)).format('0,0.00')}
                                                className="form-control form-control-gray mr-3 ir-balance"
                                                id="penalty_amount"
                                                onChange={this.handleChange}
                                            />
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <div className="rrs-detail-data content-hide">
                                        <label htmlFor="cc" id="lblsub-ir_header_brach_code" className="rrs-label mb-0">|</label>
                                    </div>
                                    <label htmlFor="receiver_name" id="lbl-ir_header_brach_code" className="rrs-label">Branch Code</label>
                                    <div className="rrs-detail-data">
                                        <Input
                                            tagid="ir.header.brach_code"
                                            doctype={"*"}
                                            type="text"
                                            name="brach_code"
                                            value={irData.brach_code}
                                            className="form-control ir-brach_code"
                                            id="ir-brach_code"
                                            onChange={this.handleChange}
                                            pattern="[0-9]*"
                                            maxLength="5"
                                            viewMode={viewMode}
                                            //inputMode="decimal"
                                            //step="0"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form" style={{visibility:irData.calculate_tax_flag === 1 || !this.state.irTax || (this.state.irTax && this.state.irTax.length<=1) ? "visible" : "hidden"}}>
                                    <label htmlFor="cc" id="lbl-ir_header_tax_amount" className="rrs-label mb-0">Tax Amount</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-ir_header_tax_amount" className="rrs-label"> (ภาษีมูลค่าเพิ่ม)</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="d-flex">
                                            <InputDecimalTax
                                                disabled={irData.calculate_tax_flag === 1 || irData.edit_tax_item === 1 ?"disabled":""}
                                                //tagid="ir.header.tax_amount"
                                                //doctype={"*"}
                                                visibility={irData.calculate_tax_flag === 1 || !this.state.irTax || (this.state.irTax && this.state.irTax.length<=1) ? "visible" : "hidden"}
                                                type="text"
                                                name="tax_amount"
                                                pattern="[0-9.,]*"
                                                defaultValue={numeral(irData.tax_amount).format('0,0.00')}
                                                className="form-control ir-tax_amount"
                                                id="tax_amount"
                                                onChange={(event) => this.handleChange(event)}
                                                onPaste={this.handleChange}
                                                onBlur={this.handleDecimalBlur}
                                                inputMode="decimal"
                                                step="0,0.00"
                                                viewMode={viewMode}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="cc" id="lbl-ir_header_tax_type" className="rrs-label mb-0"> Tax Type</label>
                                    <div className="rrs-detail-data">
                                        <label htmlFor="cc" id="lblsub-ir_header_tax_type" className="rrs-label"> ประเภทภาษี</label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <div className="rrs-detail-data">
                                            <Select
                                                tagid="ir.header.tax_type"
                                                doctype={"*"}
                                                name="tax_type"
                                                defaultValue={irData.tax_type}
                                                onChange={this.handleChange}
                                                viewMode={viewMode}
                                            >
                                            <option value="">-- select --</option>
                                            {this.props.masterVats && this.props.masterVats.map((vat, index) => (
                                                 (
                                                    <option
                                                        key={index}
                                                        value={vat.value}>
                                                        {vat.display}
                                                    </option>
                                                )
                                            ))}
                                                
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        
                        <div className="row">
                        <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="label_ir_pmt_method" id="lbl-ir_header_pmt_method" className="rrs-label">Pmt Method</label>
                                    <div className="rrs-detail-data">
                                        {/* <Input
                                            type="text"
                                            name="pmt_method"
                                            value={this.state.irData.pmt_method}
                                            className="form-control ir-pmt_method"
                                            id="this.state.irData.pmt_method"
                                            onChange={this.handleChange}
                                        /> */}
                                        <Select
                                            tagid="ir.header.pmt_method"
                                            doctype={"*"}
                                            className="form-control ir-pmt_method"
                                            name="pmt_method"
                                            defaultValue={irData.pmt_method}
                                            onChange={this.handleChange}
                                            viewMode={viewMode}
                                        >
                                        {this.props.payment_methods && this.props.payment_methods.map((data, index) => (
                                             data.language === "2" && (
                                                <option
                                                    key={index}
                                                    value={data.paY_METHOD}>
                                                    {data.paY_METHOD + " " + data.paY_METHOD_DESC}
                                                </option>
                                            )
                                        ))}
                                        </Select>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="label_ir_pmt_method_sup" id="lbl-ir_header_pmt_meth_sup" className="rrs-label">Pmt Meth. Sup</label>
                                    <div className="rrs-detail-data">
                                        {/* <Input
                                            type="text"
                                            name="pmt_meth_sup"
                                            value={this.state.irData.pmt_meth_sup}
                                            className="form-control ir-pmt_meth_sup"
                                            id="this.state.irData.pmt_meth_sup"
                                            onChange={this.handleChange}
                                        /> */}
                                        <Select
                                            tagid="ir.header.pmt_meth_sup"
                                            doctype={"*"}
                                            className="form-control ir-pmt_meth_sup"
                                            name="pmt_meth_sup"
                                            defaultValue={irData.pmt_meth_sup}
                                            onChange={this.handleChange}
                                            viewMode={viewMode}
                                        >
                                        {this.props.payment_supplements && this.props.payment_supplements.map((data, index) => (
                                              (
                                                <option
                                                    key={index}
                                                    value={data.paymenT_SUPPLEMENT}>
                                                    {data.paymenT_SUPPLEMENT + " " + data.text}
                                                </option>
                                            )
                                        ))}
                                        </Select>
                                    </div>
                                </div>

                            </div>
                            
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="receiver_name" id="lbl-ir_header_bus_place" className="rrs-label">Bus.place/sectn</label>
                                    <div className="rrs-detail-data">
                                        <div className="rrs-detail-data">
                                            <Select
                                                tagid="ir.header.bus_place"
                                                doctype={"*"}
                                                name="bus_place"
                                                defaultValue={irData.bus_place}
                                                onChange={this.handleChange}
                                                viewMode={viewMode}
                                            >
                                                <option>-- select --</option>
                                                {business_places && business_places.map((businessPlaces, index) => (
                                                    businessPlaces.businesS_PLACE.match(/H.*/) && (
                                                        <option
                                                            key={index}
                                                            value={businessPlaces.businesS_PLACE}>
                                                            {businessPlaces.businesS_PLACE + " " + businessPlaces.description}
                                                        </option>
                                                    )
                                                ))}
                                                
                                            </Select>
                                            
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <label htmlFor="label_invoicing_party" id="lbl-ir_header_invoicing_party" className="rrs-label">Invoicing party</label>
                                    <div className="rrs-detail-data">
                                        
                                        {/* <DropDownList
                                            name="invoicing_party"
                                            options={this.getVendors(irData.invoicing_party)}
                                            onSelectChanged={this.handleInvoicingPartyChange}
                                            selected={irData.invoicing_party}
                                            doctype={"*"}
                                            tagid="ir.header.invoicing_party"
                                            viewMode={viewMode}
                                        >
                                        </DropDownList> */}
                                        <Input
                                            type="text"
                                            name="invoicing_party"
                                            value={irData.vendor_name}
                                            className="form-control form-control-search-2" 
                                            id="invoicing_party"
                                            onChange={(event) => this.handleChange(event)}
                                            doctype={"*"}
                                            tagid="ir.header.invoicing_party"
                                            onClick={() => window.$('#searchIRVendorModal').modal('show')}
                                            viewMode={viewMode}
                                        />
                                    </div>
                                </div>

                            </div>   
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    <div className="d-flex">
                                        <label htmlFor="cc" id="lbl-ir_header_exch_rate" className="rrs-label"> Exch. Rate</label>
                                        <label  className="checkboxcontainer rrs-fine-label margin-left10 ir-exch_rate_fixed">Fix Rate
                                            <input disabled
                                                checked={irData.exch_rate_fixed === "1"}
                                                type="checkbox"
                                                name="exch_rate_fixed"
                                                id="this.state.irData.exch_rate_fixed"
                                                defaultValue={irData.exch_rate_fixed}
                                                onChange={this.handleChange}
                                            />
                                            <span className="form-control-gra checkboxmark chm-ir-fix-rate-flag" style={{backgroundColor: '#ccc'}} />
                                        </label>
                                    </div>
                                    <div className="rrs-detail-data">
                                        <Input
                                            disabled={irData.exch_rate_fixed === "1"? "disabled":""}
                                            type="text"
                                            name="exch_rate"
                                            className="form-control ir-exch-rate"
                                            id="ir_exch_rate"
                                            value={irData.exch_rate}
                                            onChange={this.handleChange}
                                            onBlur={this.handleDecimalBlur}
                                            pattern="[0-9.]*"
                                            inputMode="decimal"
                                            step="0,0.00000"
                                            viewMode={viewMode}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-4 col-lg-4">
                                <div className="rrs-form">
                                    
                                    <label htmlFor="cc" id="lbl-ir_header_exch_rate_date" className="rrs-label">Exch. Rate Date</label>
                                    <div className="rrs-detail-data">
                                        <Input
                                            tagid="ir.header.exch_rate_date"
                                            doctype={"*"}
                                            disabled={irData.exch_rate_fixed === "1"?"disabled":""}
                                            type="text"
                                            className="form-control js-datepicker ir-exch-rate-date"
                                            defaultValue={irData.exch_rate_date
                                                ? moment(irData.exch_rate_date).format('DD/MM/YYYY')
                                                : ""}
                                            name="exch_rate_date"
                                            id="exch_rate_date"
                                            onChange={this.handleExchRateChange}
                                            onBlur={this.handleExchRateChange}
                                            placeholder="dd/mm/yyyy"
                                            data-date-format="dd/mm/yyyy" 
                                            viewMode={viewMode}
                                            
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="rrs-detail py-1">  
                  
                    <Tabs
                            value={this.state.valueTabs}
                            onChange={handleChangeTabs}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                            >
                            <AntTab label="Withholding Tax" {...AntTabProps(0)} />
                            { /*(irData.calculate_tax_flag !== undefined && irData.calculate_tax_flag === 0) &&*/
                            <AntTab label="Tax"  {...AntTabProps(1)} /> }
                    </Tabs>    
                    </div>
                    {this.state.valueTabs === 0 &&<div className="rrs-detail py-1">
                        <div className="sp-table-container">
                            <div className="row no-gutters sp-table-content">
                                <table className="sp-table table rrs-table-2">
                                    <thead>
                                        <tr className="sp-table-header">
                                            <th className="th-table text-center"><div className="th-text">Name of W / hld.tx.typ  </div></th>
                                            <th className="th-table text-center"><div className="th-text">W / tax code</div></th>
                                            <th className="th-table text-center"><div className="th-text">W / tax base FC</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-center">P1 (02.03,53) At Pay. (หัก ณ ที่จ่าย) #1</td>
                                            <td className="text-center">
                                                <div className="rrs-detail-data">
                                                    
                                                    <Select
                                                        name="wtax_code1"
                                                        value={irData.wtax_code1}
                                                        onChange={this.handleChange}
                                                        className="form-control wtax_code1"
                                                        viewMode={viewMode}
                                                    >
                                                        <option value="">-- select --</option>
                                                        {with_codes && with_codes.map((wtCode1, index) => (
                                                            wtCode1.countrY_KEY === "TH" && wtCode1.language === "2" && wtCode1.indicator === "P1" && (
                                                                <option
                                                                    key={index}
                                                                    value={wtCode1.withholdinG_CODE}>
                                                                    {wtCode1.withholdinG_CODE + " - " + wtCode1.description}
                                                                </option>
                                                            )
                                                        ))}                                                        
                                                    </Select>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                
                                                <InputDecimal
                                                    type="text"
                                                    name="wtax_fc1"
                                                    defaultValue={irData.wtax_fc1 && numeral(irData.wtax_fc1).format('0,0.00')}
                                                    className="form-control wtax_fc1"
                                                    id="wtax_fc1"
                                                    onChange={this.handleChange}
                                                    onBlur={this.handleDecimalBlur}
                                                    pattern="[0-9,.]*"
                                                    inputMode="decimal"
                                                    step="0,0.00"
                                                    viewMode={viewMode}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center">P2 (02.03,53) At Pay. (หัก ณ ที่จ่าย) #2</td>
                                            <td className="text-center">
                                                <div className="rrs-detail-data">
                                                    
                                                    <Select
                                                        disabled={!irData.wtax_code1?"disabled":""}
                                                        name="wtax_code2"
                                                        value={irData.wtax_code2}
                                                        onChange={this.handleChange}
                                                        className="form-control wtax_code2"
                                                        viewMode={viewMode}
                                                    >
                                                        <option value="">-- select --</option>
                                                        {with_codes && with_codes.map((wtCode2, index) => (
                                                            wtCode2.countrY_KEY === "TH" && wtCode2.language === "2" && wtCode2.indicator === "P2" && (
                                                                <option
                                                                    key={index}
                                                                    value={wtCode2.withholdinG_CODE}>
                                                                    {wtCode2.withholdinG_CODE + " - " + wtCode2.description}
                                                                </option>
                                                            )
                                                        ))}                                                        
                                                    </Select>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                               
                                                <InputDecimal
                                                    disabled={!irData.wtax_code1?"disabled":""}
                                                    type="text"
                                                    name="wtax_fc2"
                                                    defaultValue={irData.wtax_fc2 && numeral(irData.wtax_fc2).format('0,0.00')}
                                                    className="form-control wtax_fc2"
                                                    id="wtax_fc2"
                                                    onChange={this.handleChange}
                                                    onBlur={this.handleDecimalBlur}
                                                    pattern="[0-9.]*"
                                                    inputMode="decimal"
                                                    step="0,0.00"
                                                    viewMode={viewMode}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}
                    
                    {this.state.valueTabs === 1 &&<div className="rrs-detail py-1">
                        <div className="sp-table-container" style={{with:700}}>                            
                            <div className="row no-gutters sp-table-content" style={{width: 700}}>
                                <table className="sp-table table rrs-table">
                                    <thead>
                                        <tr className="sp-table-header">
                                            <th className="th-table"><div className="th-text">Tax doc.currency</div></th>
                                            <th className="th-table"><div className="th-text">Base Amount</div></th>
                                            <th className="th-table"><div className="th-text">Tax Code</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.irTax && this.state.irTax.map((row, index) => {
                                            return(
                                            <tr key={('Tax'+index)}>     
                                                <td key={('Tax2'+index)}>

                                                    <InputDecimalIR
                                                        className="form-control"
                                                        name={"tax_doc_currency"}
                                                        value={row.tax_doc_currency}
                                                        id="tax_doc_currency"
                                                        onChange={(event) => this.handleChangeItemTax(event, index)}
                                                        onBlur={(event) => this.handleDecimalItemTaxBlur(event, index)}
                                                        pattern="[0-9.]*"
                                                        inputMode="decimal"
                                                        step="0,0.00"
                                                        viewMode={viewMode}
                                                        disabled={this.state.irData.calculate_tax_flag === null || (this.state.irData.calculate_tax_flag === 1) || (this.state.irData.calculate_tax_flag === 0 && this.state.irData.edit_tax_head === 1)}
                                                    />
                                                </td>
                                                <td key={('Tax4'+index)}>

                                                <InputDecimalIR
                                                    className="form-control"
                                                    name={"base_amount"}
                                                    value={row.base_amount}
                                                    id="base_amount"
                                                    onChange={(event) => this.handleChangeItemTax(event, index)}
                                                    onBlur={(event) => this.handleDecimalItemTaxBlur(event, index)}
                                                    pattern="[0-9.]*"
                                                    inputMode="decimal"
                                                    step="0,0.00"
                                                    viewMode={viewMode}
                                                    disabled={this.state.irData.calculate_tax_flag === null || (this.state.irData.calculate_tax_flag === 1) || (this.state.irData.calculate_tax_flag === 0 && this.state.irData.edit_tax_head === 1)}
                                                />
                                                </td>
                                                <td key={('Tax3'+index)}>  
                                                    <label className="label-full text-grid" style={{textAlign:"left",width: "100%"}}>{row.tax_code_name}</label>                                              
                                                </td>
                                            </tr>
                                            );})}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}

                    <div className="rrs-detail py-1">
                        <div className="sp-table-container">
                            <div className="row rrs-table-hdr-wrap">
                                <div className="col"><h2 className="rrs-table-hdr">รายการรับสินค้า - บริการ</h2></div>
                            </div>
                            
                            <div className="row no-gutters sp-table-content">
                                <table className="sp-table table rrs-table">
                                    <thead>
                                        <tr className="sp-table-header">
                                            <th className="th-table">
                                                <div className="th-text">
                                                <Checkbox disabled={viewMode?"disabled":""}
                                                    key={`header-goods-checkall`}
                                                    checked={checkall}
                                                    onChange={(event) => this.handleSelectAllClick(event)}
                                                    inputProps={{ "aria-label": "select all item" }}
                                                    color="primary"
                                                    viewMode={viewMode}
                                                    style={{paddingLeft:0}}
                                                />
                                                </div>
                                            </th>
                                            <th className="th-table"><div className="th-text">Item</div></th>
                                            <th className="th-table"><div className="th-text">Amount</div></th>
                                            <th className="th-table"><div className="th-text">Received Qty.</div></th>
                                            <th className="th-table"><div className="th-text">Unit</div></th>
                                            <th className="th-table"><div className="th-text">Item Text</div></th>
                                            <th className="th-table"><div className="th-text">Tax Code</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.irItem && this.state.irItem.map((row, index) => {
                                            const isItemSelected = row.checked === "1"
                                            return(
                                        <tr key={('It'+index)}>    
                                            <td padding="checkbox">
                                                <CheckerBox
                                                    checked={isItemSelected}
                                                    name="irItem.checked"
                                                    color="primary"
                                                    onChange={(event) => this.handleClick(event, index)}
                                                    viewMode={viewMode}
                                                />
                                            </td>
                                            <td><label className="label-full text-grid">{index+1}</label></td>
                                            <td>
                                                {row.checked === "1" && (
                                                    <InputDecimal
                                                        className="form-control"
                                                        name={"amount"}
                                                        defaultValue={numeral(row.amount).format('0,0.00')}
                                                        id="amount"
                                                        onChange={(event) => this.handleChangeItem(event, index)}
                                                        onBlur={(event) => this.handleDecimalItemBlur(event, index)}
                                                        pattern="[0-9.]*"
                                                        inputMode="decimal"
                                                        step="0,0.00"
                                                        viewMode={viewMode}
                                                    />
                                                )}
                                                {(row.checked === "0" || row.checked === "") && (<label className="label-full text-grid">{numeral(row.amount).format('0,0.00')}</label>)}
                                                
                                            </td>
                                            {/*  */}
                                            <td>
                                                {row.checked === "1" && (row.gr_receive_qty != null || t_PO_DETAIL.service_based_flag) && (
                                                    <InputDecimal
                                                        className="form-control"
                                                        name={"receive_qty"}
                                                        defaultValue={numeral(row.receive_qty).format('0,0.000')}
                                                        id="receive_qty"
                                                        onChange={(event) => this.handleChangeItem(event, index)}
                                                        onBlur={(event) => this.handleDecimalItemBlur(event, index)}
                                                        pattern="[0-9.]*"
                                                        inputMode="decimal"
                                                        step="0,0.000"
                                                        floatingPoint={3}
                                                        viewMode={viewMode}
                                                    />
                                                )} 
                                                {row.gr_receive_qty === null && (
                                                    <label className="label-full text-grid"/>
                                                )}                                               
                                            </td>
                                            <td><label className="label-full text-grid">{row.order_unit}</label></td>
                                            <td><label className="label-full text-grid">{row.item_text}</label></td>
                                            <td>    
                                                {row.checked === "1" && (
                                                    <Select
                                                    className="form-control"
                                                    name={"tax_code"}
                                                    value={row.tax_code}
                                                    onChange={e => this.handleChangeItem(e, index)}
                                                    viewMode={viewMode}
                                                    >
                                                        <option>-- select --</option>
                                                        {this.props.masterVats && this.props.masterVats.map((vat, index) => (
                                                            vat.key === "Vat" && (
                                                                <option
                                                                    key={index}
                                                                    value={vat.value}>
                                                                    {vat.value}
                                                                </option>
                                                            )
                                                        ))}
                                                        
                                                    </Select>
                                                )}                                                
                                            </td>
                                        </tr>
                                            );
                })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {t_PO_DETAIL.po_contract_no != null && (
                        <div className="rrs-detail py-1" >
                            <div className="row sp-table-content-footer" >
                                <div className="col-12 sp-header-button-panel2 justify-content-center">
                                    <a className="sp-btn-icon btn-del" onClick={() => this.goBack()}>
                                        <i className="icon btn-order-delete" />
                                        <span className="sp-btn-icon-label">Back</span>
                                    </a>
                                    <a className="sp-btn-icon btn-save-draft" onClick={() => this.saveIR()} style={{ visibility: viewMode ? "hidden" : "visible" }} >
                                        <i className="icon btn-order-savedraft" />
                                        <span className="sp-btn-icon-label">Save</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
                )}
            </div>

        )
    }
}

const mapStateToProps = state => {
    const { MasterRedux, MainRedux } = state
    return {
        viewMode : MainRedux.viewMode,
        t_IR_DETAIL:MainRedux.t_IR_DETAIL,
        t_IR_ITEM:MainRedux.t_IR_ITEM,
        t_IR_TAXS:MainRedux.t_IR_TAXS,
        t_IR_ONE_TIME_VENDOR:MainRedux.t_IR_ONE_TIME_VENDOR,
        t_PO_DETAIL:MainRedux.t_PO_DETAIL,
        t_HEADER:MainRedux.t_HEADER,
        t_GR_DETAIL:MainRedux.t_GR_DETAIL,
        t_GR_ITEM:MainRedux.t_GR_ITEM,
        t_GR_SERVICE:MainRedux.t_GR_SERVICE,
        t_GR_SERVICELINE:MainRedux.t_GR_SERVICELINE,
        t_MR_DETAIL:MainRedux.t_MR_DETAIL,
        payment_terms: MasterRedux.payment_terms,
        payment_methods: MasterRedux.payment_methods,
        payment_supplements: MasterRedux.payment_supplements,
        taxes: MasterRedux.taxes,
        vats: MasterRedux.vats,
        oneTimeVendorModal: MainRedux.oneTimeVendorModal,
        masterVats: MasterRedux.masterVats,
        currency_codes:MasterRedux.currency_codes,
        regions: MasterRedux.regions,
    }
}     

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction)),
        updateIR_OneTimeVendor: (data) => dispatch(updateIR_OneTimeVendorAction(data)),
        getExchangeRate: (formAmount,fromCur,toCur,validDate) => dispatch(getExchangeRateAction(formAmount,fromCur,toCur,validDate)),
        getVendor : () => dispatch(getVendorInfoAction()),
        getVendorInformation:(vendorNo)=>dispatch(getVendorInformationAction(vendorNo)),
        getIR_Reference:(poNo, reference, tranNo, running, invoiceDate,vendor_code)=>dispatch(getIR_ReferenceAction(poNo, reference, tranNo, running, invoiceDate,vendor_code)),
        getBusinessPlace: () => dispatch(getBusinessPlaceAction()),
        getWithCode: () => dispatch(getWithCodeAction(null,null,null)),
        getWithCodeByVendor: (countryKey,language,withholdingCode,vendorCode , company_code , payment_type) => dispatch(getWithCodeByVendorAction(countryKey,language,withholdingCode,vendorCode , company_code , payment_type)),
        setChangeData:() => dispatch(setStatusChangeIRAction()),
        setSaveData:()=> dispatch(setStatusSaveIRAction()),
        GETEWHTConditionValidationCheckInquiry:(comcode , vendor , wtax_code1, wtax_code2,post_date,pmt_method) => dispatch(GETEWHTConditionValidationCheckInquiryAction(comcode , vendor , wtax_code1, wtax_code2,post_date,pmt_method)),

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InvoiceReceive)